<script>
    const numSteps = 20.0

    let elements
    let prevRatio = 0.0

    window.addEventListener("load", (event) => {
        elements = document.querySelectorAll('section')
        elements.forEach((element, index) => {
            addTransitionClasses(element, index)
            createObserver(element)
        })
    }, false)

    function addTransitionClasses(element, index) {
        if (element.classList.contains('sticky-component')) {
            element.classList.add('from-below')
        }
        else if (element.classList.contains('insights-block')){
            element.classList.add('fade-in')
        }
        else {
            element.classList.add(index % 2 === 0 ? 'from-left' : 'from-right')
        }
    }

    function createObserver(element) {
        let observer;
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: buildThresholdList()
        };

        observer = new IntersectionObserver(handleIntersect, options)
        observer.observe(element)
    }

    function buildThresholdList() {
        let thresholds = []
        let numSteps = 20

        for ( let i = 1.0; i <= numSteps; i ++ ) {
            let ratio = i / numSteps
            thresholds.push(ratio)
        }

        thresholds.push(0)
        return thresholds
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > prevRatio) {
                entry.target.classList.add('visible')
            }

            prevRatio = entry.intersectionRatio
        });
    }
</script>
